export const MODAL_INFO = 'MODAL_INFO';
export function showModal(node) {
    return dispatch => {
        dispatch({
            type: MODAL_INFO,
            content: true,
            modal: true,
            node: node
        });
    }
}
export function hideModal(node) {
    return dispatch => {
        dispatch({
            type: MODAL_INFO,
            content: false,
            modal: false,
            node: node
        });
    }
}
export function showModalContent(node) {
    return dispatch => {
        dispatch({
            type: MODAL_INFO,
            content: true,
            modal: true,
            node: node
        });
    }
}
export function hideModalContent(node) {
    return dispatch => {
        dispatch( {
            type: MODAL_INFO,
            content: false,
            modal: true,
            node: node
        });
    }
}